import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const VentilationFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M7.99833 11.1001C7.33843 10.3076 6.89995 9.2239 6.89995 7.80019C6.89995 5.82687 7.74233 4.50667 8.84908 3.70981C9.90993 2.946 11.1559 2.7002 12 2.7002H12.9V7.99886C13.6925 7.33894 14.7762 6.90044 16.2 6.90044C18.1733 6.90044 19.4935 7.74282 20.2903 8.84956C21.0542 9.91042 21.3 11.1564 21.3 12.0004V12.9004H16.0016C16.6615 13.6929 17.1 14.7767 17.1 16.2004C17.1 18.1737 16.2576 19.4939 15.1508 20.2908C14.09 21.0546 12.844 21.3004 12 21.3004H11.1L11.1 16.0017C10.3075 16.6616 9.2237 17.1001 7.79995 17.1001C5.82662 17.1001 4.50643 16.2578 3.70957 15.151C2.94575 14.0902 2.69995 12.8442 2.69995 12.0001V11.1001L7.99833 11.1001Z"
      />
    </SvgIcon>
  );
});
